import { useState } from 'react';
import type { Product } from '../../../types/product';

export const DEFAULT_MAX_SELECTION = 5;

interface UseProductMultiSelectionParams {
  products: Product[];
  initialProducts?: Product[];
  maxSelection?: number;
}

export function useProductMultiSelection({
  products,
  initialProducts,
  maxSelection = DEFAULT_MAX_SELECTION,
}: UseProductMultiSelectionParams) {
  const [selectedProductsMap, setSelectedProductsMap] = useState<Map<number, Product>>(() => {
    if (initialProducts && initialProducts.length > 0) {
      return new Map(initialProducts.map((p) => [p.id, p]));
    }
    return new Map();
  });

  const handleToggleProductSelection = (productId: number) => {
    const product = products.find((p) => p.id === productId);
    if (!product) return;

    setSelectedProductsMap((prev) => {
      const newMap = new Map(prev);
      if (newMap.has(productId)) {
        newMap.delete(productId);
      } else {
        if (newMap.size >= maxSelection) {
          alert(`Ви можете вибрати максимум ${maxSelection} продуктів`);
          return prev;
        }
        newMap.set(productId, product);
      }
      return newMap;
    });
  };

  const handleSelectAll = (allProducts: Product[]) => {
    if (allProducts.length > maxSelection) {
      alert(`Ви можете вибрати максимум ${maxSelection} продуктів`);
    }
    setSelectedProductsMap(new Map(allProducts.slice(0, maxSelection).map((p) => [p.id, p])));
  };

  return {
    selectedProductsMap,
    handleToggleProductSelection,
    handleSelectAll,
  };
}
